import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const elPubTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'EL_PUBLICATIONS');


export const requestElPublications = () => {
    return {
        type: elPubTypes.REQUEST,
    };
};

export const receiveElPublications = (response) => {
    return {
        type: elPubTypes.RECEIVE,
        data: response,
    };
};

export const receiveElPublicationsError = (response) => {
    return {
        type: elPubTypes.ERROR,
        error: response,
    };
};

export const updateElPublications = (customerId, value) => {
    return dispatch => {
        let apiUrl = ''
        if (value == true ) {
            apiUrl = `/api/v1/customer/${customerId}/electronicpublication?el_pub=true`
        } else {
            apiUrl = `/api/v1/customer/${customerId}/electronicpublication`
        }

        dispatch(requestElPublications());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveElPublications(response));
            } catch (e) {
                dispatch(receiveElPublicationsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};